import * as Sentry from "@sentry/react";

/**
 * Initializes Sentry for error tracking and performance monitoring.
 * Uses VITE_SENTRY_DSN environment variable.
 */
export function initObservability() {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;

  if (!dsn) {
    if (import.meta.env.PROD) {
      console.warn("Sentry DSN not found. Observability is disabled in production.");
    }
    return;
  }

  Sentry.init({
    dsn,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, 
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", ...(supabaseUrl ? [supabaseUrl] : [])],
    // Session Replay
    replaysSessionSampleRate: 0.1, 
    replaysOnErrorSampleRate: 1.0,
    environment: import.meta.env.MODE,
  });
}

/**
 * Captures a manual exception to Sentry with optional context.
 */
export function captureException(error: unknown, context?: Record<string, unknown>) {
  console.error("[Observability] Error captured:", error instanceof Error ? error.message : String(error));
  
  if (import.meta.env.VITE_SENTRY_DSN) {
    Sentry.captureException(error, { extra: context });
  }
}
